import { Link } from "react-router-dom";
import heroFlyer from "../assets/images/hero-flyer.png";
import homeImage1 from "../assets/images/homeImage1.jpg";
import homeImage2 from "../assets/images/homeImage2.jpg";
import homeImage3 from "../assets/images/homeImage3.jpg";
import {
  appName,
  appTagline,
  heroBadge,
  gradesRange,
  whatsappUrl,
} from "../common";

const pillars = [
  {
    icon: "⚙️",
    title: "STEM & logical thinking",
    text: "Build reasoning, patterns, and scientific curiosity through guided challenges.",
  },
  {
    icon: "🦾",
    title: "Robotics & electronics",
    text: "Sensors, motors, and circuits come alive in projects students can touch and test.",
  },
  {
    icon: "{ }",
    title: "Coding & AI basics",
    text: "From first programs to simple AI ideas — clear steps, real outcomes.",
  },
  {
    icon: "🤖",
    title: "Hands-on projects & experiments",
    text: "Learning by doing: kits, builds, and teamwork that mirror how tech works in the world.",
  },
];

const values = [
  "Experiential learning",
  "Skill-based education",
  "Practical knowledge",
];

const Home = () => {
  return (
    <div className="page home-page">
      <section className="hero">
        <div className="hero-grid">
          <div className="hero-copy">
            <p className="hero-eyebrow">{appName}</p>
            <p className="hero-tagline">{appTagline}</p>
            <span className="hero-badge">{heroBadge} ★</span>
            <div className="hero-nep" role="note">
              <span className="hero-nep-line" aria-hidden />
              <span className="hero-nep-text">Aligned with NEP 2020</span>
              <span className="hero-nep-line" aria-hidden />
            </div>
            <h1 className="hero-title">
              <span className="hero-title-light">STEM &amp; robotics</span>{" "}
              <span className="hero-title-accent">learning</span>
            </h1>
            <p className="hero-sub">
              Learning by doing · Innovation · Creativity
            </p>
            <p className="hero-lead">
              We help schools and families give young learners future-ready skills
              through structured robotics, coding, and AI foundations — always
              grounded in curiosity and real projects.
            </p>
            <div className="hero-actions">
              <a className="btn btn-primary" href={whatsappUrl} target="_blank" rel="noreferrer">
                Chat on WhatsApp
              </a>
              <Link className="btn btn-ghost" to="/contact">
                Contact us
              </Link>
            </div>
          </div>
          <div className="hero-visual">
            <img
              src={heroFlyer}
              alt={`${appName} — ${appTagline}, programs for ${gradesRange}`}
              className="hero-flyer-img"
            />
          </div>
        </div>
      </section>

      <section className="section programs-bar-section">
        <div className="programs-bar">
          <span className="programs-bar-icon" aria-hidden>
            ⚙️
          </span>
          <p>
            <strong>Programs for</strong>{" "}
            <span className="programs-bar-highlight">{gradesRange}</span>
          </p>
        </div>
      </section>

      <section className="section section-block">
        <h2>What young minds build with us</h2>
        <p className="section-text">
          Our sessions blend STEM thinking with robotics kits, electronics, and
          coding — so students understand how ideas become working systems.
        </p>
        <ul className="pillar-grid">
          {pillars.map((item) => (
            <li key={item.title} className="pillar-card">
              <span className="pillar-icon" aria-hidden>
                {item.icon}
              </span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="section section-block values-split">
        <div className="values-copy">
          <h2>How we teach</h2>
          <p className="section-text left">
            National Education Policy 2020 emphasises holistic, skill-oriented
            learning. Our workshops and school programs are designed to complement
            that direction — with safe, age-appropriate kits and clear learning paths.
          </p>
          <ul className="value-checklist">
            {values.map((line) => (
              <li key={line}>
                <span className="value-tick" aria-hidden>
                  ✓
                </span>
                {line}
              </li>
            ))}
          </ul>
          <p className="school-cta">
            <strong>Schools:</strong> DM or write to us to plan a collaboration —
            curriculum tie-ins, lab setups, and batch-wise programs.
          </p>
          <Link className="btn btn-outline" to="/contact">
            Partner with your school
          </Link>
        </div>
        <div className="values-gallery">
          <h2 className="values-gallery-heading">Learning in action</h2>
          <div className="image-grid image-grid--compact">
            <img src={homeImage1} alt="Robotics class" />
            <img src={homeImage2} alt="Students building robots" />
            <img src={homeImage3} alt="Hands-on robotics learning" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
